<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="861px" class="dialog" title="运单契约条款" :close-on-click-modal="false">
            <div>
                <!-- <span>{{ textContent }}</span> -->
                 <!-- <textarea name="" id="" v-model="textContent"></textarea> -->
                 <el-input v-model="textContent" type="textarea" readonly :autosize="{ minRows: 2, maxRows: 20 }" :resize="'none'"></el-input>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import textContent from './textContent'
export default {
    name:'',
    data() {
        return {
            textContent,
            dialogVisible:false
        }
    },
    methods: {
        open() {
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
        },
    }
}
</script>

<style></style>